<template >
  <section>
    <template >
      <!-- モーダル画面 -->
      <div style="display: flex;">
        <!-- 適用ロボ設定モーダル -->
        <ModalSitemapRoboApply
          :isSitemapRoboApplyModalOpen="isSitemapRoboApplyModalOpen"
          :applyRoboTargetSitemamp="applyRoboTargetSitemamp"
          :roboList="sitemapRoboList"
          :isRecruit="isRecruit"
          @returnRoboApplyModal="returnRoboApplyModal"
          @closeRoboApplyModal="closeRoboApplyModal"
        />
        <!-- サイトマップノード編集モーダル -->
        <ModalSitemapNodeEdit
          :isSitemapNodeEditModalOpen="isSitemapNodeEditModalOpen"
          :sitemapNodePath="sitemapNodePath"
          @returnEditSitemapNode="returnEditSitemapNode"
          @closeNodeEditModal="closeNodeEditModal"
        />
        <!-- タグ設定モーダル -->
        <ModalTagEdit
          :isTagEditModalOpen="isTagEditModalOpen"
          :isTagProgress="isTagProgress"
          :targetObj="targetSitemap"
          :currentTagList="targetTagNameList"
          :defaultTagList="defaultTagList"
          @addTag="addSitemapTag"
          @deleteTag="deleteSitemapTag"
          @closeTagEditModal="closeTagEditModal"
        />
        <!-- タグ一括設定モーダル -->
        <ModalTagCollectEdit
          :isTagCollectEditModalOpen="isTagCollectEditModalOpen"
          :isTagProgress="isTagProgress"
          :pageType="pageType"
          :sitemapRecruitListAll="sitemapRecruitListAll"
          :sitemapCustomListAll="sitemapCustomListAll"
          :selectedSitemapRoot="selectedSitemapRoot"
          :currentTagList="allTagNameList"
          :defaultTagList="defaultTagList"
          @collectAddTag="collectAddTag"
          @collectDeleteTag="collectDeleteTag"
          @closeTagCollectEditModal="closeTagCollectEditModal"
        />
      </div>
    </template >
    <!-- ページ番号 -->
    <div class="tab-header" v-if="!isHomePage">
      <b-pagination
        :total="countContents"
        :current.sync="pages"
        :per-page="perPage"
        :disabled="isPageLoading">
      </b-pagination>
      <div v-if="isLoading && !isPageLoading">
        <span class="mdi mdi-spin mdi-loading mdi-24px" style="padding-right: 48px">読み込み中です。</span>
      </div>
    </div>
    <!-- タグ検索 -->
    <!--
    <b-autocomplete
      size="is-small"
      style="width: 250px; height: 27px; margin-left: 32px; margin-right: 8px; margin-bottom: 24px;"
      v-model="autocompleteWords"
      placeholder="🔍タグ名で検索"
      :open-on-focus="true"
      :data="filteredTagList"
      field="tag"
      @select="option => searchWords = option.tag">
    </b-autocomplete>
    -->
    <!-- 新規パス追加 -->
    <div class="tab-header" v-else>
      <b-field>
        <div class="split-box-form">
          <div class="split-box-left">
            <p>新規追加</p>
          </div>
          <div class="split-box-right">
            <input class="input is-small" placeholder="新規追加するパスを'/'から入力" v-model="addNodePath"/>
            <button class="button is-primary is-small" @click="addSitemapNode" :disabled="addNodePath.length <= 0">
              新しく追加
            </button>
          </div>
        </div>
      </b-field>
      <div v-if="isLoading">
        <span class="mdi mdi-spin mdi-loading mdi-24px" style="padding-right: 48px">読み込み中です。</span>
      </div>
    </div>
    <!-- 一覧テーブル -->
    <div class="init-page" v-if="isPageLoading">
      <div class="load-display">
        <span class="mdi mdi-spin mdi-loading mdi-48px" style="padding-right: 48px"/>
        <p>サイトマップを読み込み中です。</p>
      </div>
    </div>
    <div>
      <table style="width: 100%;">
        <!-- テーブルヘッダ -->
        <tr style="border-bottom: solid 2px #ccc; background: white;">
          <th class="cell-class th-class" style="width: 64px;">状態</th>
          <th class="cell-class th-class" style="width: 30%">{{getPageTypeName}}</th>
          <th class="cell-class th-class" style="text-align: left;">
            表示ロボ<br>
            <span style="color: #666; font-size: 12px">
              表示順は下のロボを<br>左右に直接移動することで変更できます
            </span>
          </th>
          <th class="cell-class th-class" style="width: 25%">初回起動<br>
            <!-- 求人ページのタブのみ、応募フォームロボ化時の注意文言を表示する -->
            <span style="color: #666; font-size: 12px" v-if="getPageTypeName === '求人ページ'">
              応募フォームロボ化設定時は、<br>
              初回起動設定が空欄の場合、表示されない場合があります。
            </span>
          </th>
          <th class="cell-class th-class" v-if="isHomePage">編集</th>
          <th class="cell-class th-class" v-if="isHomePage">削除</th>
        </tr>
        <!-- リストなし -->
        <tr style="border-bottom: solid thin #ccc; background: white;" v-if="selectedList.length <= 0 && !isLoading">
          <td colspan="5" v-if="isHomePage">表示できる{{getPageTypeName}}がありませんでした。</td>
          <td colspan="7" v-else>表示できる{{getPageTypeName}}がありませんでした。</td>
        </tr>
        <!-- リスト -->
        <tr class="cells" v-for="(target, index) in getSelectedList" :key="`Z-${index}`" v-else>
          <!-- 状態 -->
          <td class="cell-class" style="text-align: center;">
            <span class="mdi mdi-checkbox-blank-circle" style="color: green;" v-if="isRecruit"/>
            <span class="mdi mdi-checkbox-blank-circle" style="color: green;" v-else-if="target.is_widget"/>
            <span class="mdi mdi-checkbox-blank-circle-outline" v-else/>
          </td>
          <!-- 求人ページかカスタムページまたはサイトマップノード -->
          <td class="cell-class" style="text-align: left;">
            <a :href="getLink(target)" target="_blank" rel="noopener">{{getLinkTitle(target)}}</a>
          </td>
          <!-- 表示ロボ -->
          <td class="cell-class bot-enable-list" style="text-align: left; min-width: 250px;">
            <div class="robo-split-box-form">
              <draggable
                class="robo-split-box-left"
                v-model="orderRoboList[target.sitemap_id]"
                @end="isDragging=false;saveRoboOrder(target, isRecruit)"
                :options="{animation: 200, group: { name: 'ROBOS', put: true, pull: true}}"
              >
                <div class="bot-enable-list" v-for="(robo, idx) in getRoboList(target)" :key="`A-${idx}`" @mouseover="roboOver(robo)" @mouseleave="roboLeave(robo)">
                  <div @mousedown.left="isDragging=true" @mouseup.left="isDragging=false">
                    <div v-if="!isDragging">
                      <Tooltip :message="getRoboName(target, robo)">
                        <img class="bot-icon" :src="getRoboIcon(robo)" >
                      </Tooltip>
                    </div>
                    <div v-else>
                      <img class="bot-icon" :src="getRoboIcon(robo)">
                    </div>
                  </div>
                  <div class="delete-button" @click="unapplyRoboConfirm(target, robo)" v-if="isIconHover(robo)===true && !isDragging">×</div>
                  <div class="edit-button" @click="changeScnList(robo)" v-if="(isIconHover(robo)===true && !isDragging) && isRoboEditPermission(robo)"><span class="mdi mdi-playlist-edit"/></div>
                  <div :class="{'start-tag': isStartRobo(target, robo)}"></div>
                </div>
              </draggable>
              <div class="robo-split-box-right">
                <button class="button" style="border-radius: 50%; height: 36px; width: 36px;" @click="openRoboApplyModal(target)">+</button>
              </div>
            </div>
          </td>
          <!-- 初回起動 -->
          <td class="cell-class">
            <div class="select">
              <select v-model="selectStartRobo[target.sitemap_id]"
                @change="setStartRobo(target, selectStartRobo[target.sitemap_id], isRecruit)"
                :disabled="Boolean(getRoboList(target) <= 0)"
                style="min-width: 300px; max-width: 300px;">
                <option v-for="(robo, idx) in getRoboList(target)" :key="`C-${idx}`" :value="robo" style="min-width: 200px; max-width: 200px;">
                  {{ robo.data.name }}
                </option>
              </select>
            </div>
          </td>
          <!-- 編集 -->
          <td class="cell-class" style="text-align: center;" v-if="!isRecruit">
            <button class="button is-primary" @click="openNodeEditModal(target)"><span class="mdi mdi-playlist-edit"></span></button>
          </td>
          <!-- 削除 -->
          <td class="cell-class" style="text-align: center;" v-if="!isRecruit">
            <button class="button is-danger" @click="deleteSitemapNodeConfirm(target)"><span class="mdi mdi-delete"></span></button>
          </td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
import { mapState }          from 'vuex'
import draggable             from 'vuedraggable'
import Tooltip               from '@/components/atoms/tooltips/Tooltip'
import ModalTagEdit          from '@/components/organisms/common/ModalTagEdit'
import ModalSitemapNodeEdit  from '@/components/organisms/users/sitemap/ModalSitemapNodeEdit'
import ModalSitemapRoboApply from '@/components/organisms/users/sitemap/ModalSitemapRoboApply'
import ModalTagCollectEdit   from '@/components/organisms/users/sitemap/ModalTagCollectEdit'
import {
  isRoboEditPermission,
} from '@/functions/checkPermission'

// 外部関数
import {
  /** ページ情報初期値 */
  SITEMAP_OVERALL,
  /** 操作種別定義 */
  SITEMAP_ACTION_TYPE,
  /** ページ種別定義 */
  SITEMAP_PAGE_TYPE,
  /** コンテンツ種別 */
  SITEMAP_CONTENT_TYPE,
  /** ディスパッチ先定義 */
  SITEMAP_DISPATCH,
  /** 適用ロボ解除確認タイアログ表示 */
  unapplyRoboConfirm,
  /** サイトマップノード削除確認ダイアログ表示 */
  deleteSitemapNodeConfirm
} from '@/functions/users/sitemapFunc'

export default {
  name: 'SitemapTable',
  componentName: 'SitemapTable',
  components: {
    Tooltip,
    ModalTagEdit,
    ModalSitemapNodeEdit,
    ModalSitemapRoboApply,
    ModalTagCollectEdit,
    draggable
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('chatbot', ['chatbots']),
    ...mapState('sitemap', ['isLoading', 'sitemapRoboList', 'selectedSitemapRoot',
                            'sitemapRootList', 'sitemapRecruitList', 'countRecruitPage',
                            'sitemapCustomList', 'countCustomPage',
                            'recruitTagList', 'customTagList', 'homePageTagList',
                            'sitemapRecruitListAll', 'sitemapCustomListAll','sitemapWaitList']),
    /** 適用ロボと適用ミニロボのリスト取得 */
    getRoboList () {
      // 適用ロボと適用ミニロボの一覧
      return function (target) {
        return this.sortRoboOrder(target)
      }
    },
    /** ページ種別取得 */
    getPageTypeName () {
      if (this.pageType === SITEMAP_PAGE_TYPE.HOME_PAGE) {
        // ホームページ
        return 'URL'
      } else if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
        // カスタムページ
        return 'カスタムページ'
      } else {
        // 求人ページ
        return '求人ページ'
      }
    },
    /** 求人ページ判定 */
    isHomePage () {
      if (this.pageType === SITEMAP_PAGE_TYPE.HOME_PAGE) {
        // ホームページ
        return true
      } else {
        // 求人ページまたはカスタムページ
        return false
      }
    },
    /** タグ名リスト取得 */
    getTagList () {
      return function (target) {
        let tag_list = []
        if (target.tag_list) {
          for (const tag of target.tag_list) {
            tag_list.push(tag.name)
          }
        }
        return tag_list
      }
    },
    /** 表示一覧取得 */
    getSelectedList () {
      this.tabPageSet()
      return this.selectedList
    }
  },
  data () {
    return {
      /** 読み込み中フラグ */
      isPageLoading              : true,
      /** タグ設定モーダル作成中フラグ */
      isTagProgress              : false,
      /** タグ一括設定モーダルオープンフラグ */
      isTagCollectEditModalOpen  : false,
      /** タグ設定モーダルオープンフラグ */
      isTagEditModalOpen         : false,
      /** 求人ページまたはカスタムページ：true、ホームページ：false */
      isRecruit                  : true,
      /** ページ種別 */
      contentType                : this.pageType,
      /** サイトマップノード編集モーダルフラグ */
      isSitemapNodeEditModalOpen : false,
      /** 適用ロボ設定モーダルフラグ */
      isSitemapRoboApplyModalOpen: false,
      /** 新規追加対象サイトマップノード */
      addNodePath                : '',
      /** 編集対象サイトマップノード */
      editNode                   : '',
      /** 編集ノードパス */
      sitemapNodePath            : '',
      /** 削除対象サイトマップノード */
      deleteNode                 : '',
      /** 表示ページ */
      pages                      : SITEMAP_OVERALL.PAGES,
      /** 1ページ表示件数 */
      perPage                    : SITEMAP_OVERALL.PER_PAGE,
      /** コンテンツ総件数 */
      countContents              : 0,
      /** 表示対象リスト */
      selectedList               : [],
      /** 適用ロボ設定対象 */
      applyRoboTargetSitemamp    : {},
      /** 提要ロボ除外対象サイトマップ */
      unapplyTargetSitemap       : {},
      /** 適用除外対象ロボ */
      unapplyRoboTarget          : {},
      /** 適用対象ロボ */
      applyRoboTarge             : {},
      /** 初回起動ロボ */
      selectStartRobo            : {},
      /** タグ設定対象のサイトマップ */
      targetSitemap              : {},
      /** カレントタグ名リスト */
      targetTagNameList          : [],
      /** 全タグ名リスト */
      allTagNameList             : [],
      /** デフォルトタグリスト */
      defaultTagList             : [
        'シニア応援',
        '社員登用あり',
        '昇給・昇格あり',
        '残業なし',
        '週1日からOK',
        '週2~3日からOK',
        'シフト自由・選べる',
        '高収入・高時給',
        '交通費支給',
        '即日勤務OK',
        '急募',
        '駅から5分以内',
      ],
      /** ロボアイコンマウスオーバー */
      roboIconHover              : '',
      /** ドラッグ中フラグ */
      isDragging                 : false,
      /** 並べ替え用ロボリスト */
      orderRoboList              : [],
      /** 新規作成サイトマップのURL */
      createSitemapUrl          : '',
    }
  },
  props: {
    // ページ種別(求人ページ、カスタムページ、ホームページ)
    pageType: {
      type    : String,
      default : SITEMAP_PAGE_TYPE.RECRUIT_PAGE,
      required: true
    }
  },
  mounted () {
    this.isPageLoading = true
    // 求人ページを取得
    if (this.$route.query.pages !== undefined) {
      // ページ遷移制御
      if (this.$route.query.pages >= 1) {
        this.pages = Number(this.$route.query.pages)
        if (this.pages >= 1) {
          // 求人ページおよびカスタムページデータ取得
          this.getEploymentData()
        }
      }
    } else {
      // 求人ページおよびカスタムページデータ取得
      this.getEploymentData()
    }
  },
  watch: {
    /** カレントページ変更 */
    pages () {
      if (this.pages >= 1) {
        // 求人ページおよびカスタムページデータ取得
        this.getEploymentData()
      }
    },
    /** 求人ページリスト */
    sitemapRecruitList () {
      this.tabPageSet()
      if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
        if (this.sitemapRecruitList.length > 0) {
          this.tabPageSet()
          if (this.isTagProgress) {
            if (this.isTagEditModalOpen) {
              this.isTagProgress = false
              this.collectionTag()
            } else if (this.isTagCollectEditModalOpen) {
              this.$store.dispatch(SITEMAP_DISPATCH.GET_SITEMAP_RECRUIT_LIST_ALL)
            }
          }
        }
      }
      // タグ検索用リスト作成
      this.searchTagList = this.createTagList(this.recruitTagList)
    },
    /** カスタムページリスト */
    sitemapCustomList () {
      this.tabPageSet()
      if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
        if (this.sitemapCustomList.length > 0) {
          if (this.isTagProgress) {
            if (this.isTagEditModalOpen) {
              this.isTagProgress = false
              this.collectionTag()
            } else if (this.isTagCollectEditModalOpen) {
              this.$store.dispatch(SITEMAP_DISPATCH.GET_SITEMAP_CUSTOM_LIST_ALL)
            }
          }
        }
      }
      // タグ検索用リスト作成
      this.searchTagList = this.createTagList(this.customTagList)
    },
    /** サイトマップルート */
    sitemapRootList () {
      this.tabPageSet()
      if (this.pageType === SITEMAP_PAGE_TYPE.HOME_PAGE) {
        if (this.sitemapRootList.length > 0) {
          if (this.isTagProgress) {
            this.isTagProgress = false
            if (this.isTagEditModalOpen) {
              this.collectionTag()
            } else if (this.isTagCollectEditModalOpen) {
              this.allCollectionTag()
            }
          }
        }
      }
    },
    /** 全求人ページ */
    sitemapRecruitListAll () {
      this.isTagProgress = false
      this.allCollectionTag()
    },
    /** 全カスタムページ */
    sitemapCustomListAll () {
      this.isTagProgress = false
      this.allCollectionTag()
    },
    /** サイトマップ用ロボリスト再作成 */
    chatbots () {
      // ロボが更新されたら読み直し
      this.$store.dispatch(SITEMAP_DISPATCH.GET_SITEMAP_ROBO_LIST)
    }
  },
  methods: {
    //////////////////////////////////////////
    // サイトマップノード関連
    /** サイトマップノード編集モーダルオープン */
    openNodeEditModal (targetNode) {
      this.sitemapNodePath            = targetNode.node_url
      this.editNode                   = targetNode
      this.isSitemapNodeEditModalOpen = true
    },
    /** サイトマップノード編集モーダルクローズ */
    closeNodeEditModal () {
      this.isSitemapNodeEditModalOpen  = false
    },
    /** サイトマップノード削除確認アラート */
    deleteSitemapNodeConfirm (deleteNode) {
      const alertData = deleteSitemapNodeConfirm(deleteNode.node_url)
      this.$emit('alertConfirmDeleteSitemapNode', alertData, deleteNode)
    },
    /** 新規サイトマップノード追加 */
    addSitemapNode () {
      this.$emit('addSitemapNode', this.addNodePath)
      this.addNodePath = ''
    },
    /** サイトマップノード編集 */
    returnEditSitemapNode (editNodePath, editSitemap, initNodePath) {
      if (editSitemap !== initNodePath) {
        // 編集されていれば実行する
        if (editNodePath === '') {
          this.isSitemapNodeEditModalOpen = false
          this.$emit('dispErrorAlert', 'サイトマップ編集エラー', 'パスを入力してください。')
        } else {
          this.isSitemapNodeEditModalOpen = false
          if (editNodePath.charAt(0) !== '/') {
            editNodePath = '/' + editNodePath
          }
          const updatePath = {
            root_url : this.selectedSitemapRoot.root_url,
            target   : this.editNode,
            node_path: editNodePath
          }
          const updateData = {
            update_list: updatePath,
            action     : SITEMAP_ACTION_TYPE.EDIT_SITEMAP_NODE,
            is_mini    : false
          }
          this.$emit('updateSitemap', updateData, false)
        }
      }
    },
    //////////////////////////////////////////
    // ロボ適用関連
    /** ロボ適用モーダルオープン */
    openRoboApplyModal (target) {
      this.$emit('getSitemapRoboList')
      this.applyRoboTargetSitemamp = target
      this.isSitemapRoboApplyModalOpen = true
    },
    /** ロボ適用モーダルクローズ */
    closeRoboApplyModal () {
      this.isSitemapRoboApplyModalOpen = false
    },
    /** ロボ適用設定 */
    returnRoboApplyModal (roboApplyTarget, selectRobo, isRecruit) {
      this.closeRoboApplyModal()
      const updateList = [{
        target: roboApplyTarget,
        robo  : [selectRobo]
      }]
      const updateData = {
        update_list: updateList,
        action     : SITEMAP_ACTION_TYPE.ROBO_APPLY,
        is_mini    : selectRobo.is_mini,
      }
      this.$emit('updateSitemap', updateData, isRecruit)
    },
    /**ロボ適用除外確認アラート */
    unapplyRoboConfirm (target, unapplyRobo) {
      const alertData = unapplyRoboConfirm(this.getApplyTargetName(target), unapplyRobo.data.name)
      this.$emit('alertConfirmUnapplyRobo', alertData, target, unapplyRobo)
    },
    /** 初回起動ロボ設定 */
    setStartRobo (setStartRobotarget, startRobo, isRecruit) {
      if (!startRobo) {
        // 無ければ設定しない
        return
      }
      const updateList = {
        target: setStartRobotarget,
        robo  : startRobo
      }
      const updateData = {
        update_list: updateList,
        action     : SITEMAP_ACTION_TYPE.START_ROBO,
        is_mini    : startRobo.is_mini
      }
      this.$emit('updateSitemap', updateData, isRecruit)
    },
    /** ロボの並び順ソート */
    sortRoboOrder(target) {
      if (this.isDragging) {
        // ドラッグ中は並べ替えない
        return this.orderRoboList[target.sitemap_id]
      }
      let result = [];
      let robo_list = target.apply_robo_list.concat(target.apply_minirobo_list);

      // 対象サイトマップでの表示順抽出
      let roboOrderList = []
      let numAlign = 0
      for (const robo of robo_list) {
        let orderNum = 0
        // 対象サイトマップの並び順情報取得
        if (robo.robo_order) {
          // 並び順情報があれば従う(稀に文字列になっているので数値に変換する)
          orderNum = Number(robo.robo_order.order)
        } else {
          // 並び順情報が無ければ後ろに回す
          numAlign++
          orderNum = robo_list.length + numAlign
        }
        roboOrderList.push(
          {
            order: Number(orderNum),
            robo : robo
          }
        )
      }
      // 並び順でソート
      let sortRoboOrder = this.$_.orderBy(roboOrderList, ['order'], ['asc'])
      // 並び替えた順にリスト作成
      for (const robo_order of sortRoboOrder) {
        result.push(robo_order.robo)
      }

      // 適用ロボに並び替え後を保存
      this.orderRoboList[target.sitemap_id] = result
      // 初回起動ロボの選択状態を並び替え後に変更
      for (const robo of result) {
        if (robo.data && this.selectStartRobo[target.sitemap_id]) {
          if (robo.data.bot_id === this.selectStartRobo[target.sitemap_id].data.bot_id) {
            this.selectStartRobo[target.sitemap_id] = robo
          }
        }
      }

      return result
    },
    /** ロボ並び順保存 */
    saveRoboOrder(target, isRecruit) {
      let orderData = []
      for (const idx in this.orderRoboList[target.sitemap_id]) {
        // 並び順情報取得
        let order_data = this.orderRoboList[target.sitemap_id][idx]
        // 新しい順番に書き換え
        if (order_data) {
          // 既存があれば書き換え
          order_data.robo_order.order = Number(idx)
        } else {
          // 既存が無ければ作る
          this.orderRoboList[target.sitemap_id][idx].robo_order =
          {
            sitemap_id: target.sitemap_id,
            order     : Number(idx)
          }
        }
        // 並び順データ作成
        orderData.push({
          order_id: order_data ? order_data.order_id : null,
          is_mini : this.orderRoboList[target.sitemap_id][idx].is_mini,
          robo_pk : this.orderRoboList[target.sitemap_id][idx].data.pk,
          order   : idx,
        });
      }
      const roboOrder = {
        isRecruit : isRecruit,
        sitemap_pk: target.pk,
        order_data: orderData
      }
      this.$store.dispatch(SITEMAP_DISPATCH.UPDATE_ROBO_ORDER, roboOrder)
      this.sortRoboOrder(target)
    },
    //////////////////////////////////////////
    // タグ関連
    /** タグ一括設定モーダルオープン */
    openTagCollectEditModal () {
      this.allCollectionTag()
      this.isTagCollectEditModalOpen = true
    },
    /** 一括編集用タグ収集 */
    allCollectionTag () {
      let targetSitemapList = []
      if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
        // 求人ページ
        targetSitemapList = this.sitemapRecruitListAll
      } else if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
        // カスタムページ
        targetSitemapList = this.sitemapCustomListAll
      } else {
        // ホームページ
        targetSitemapList = this.selectedSitemapRoot.node_list
      }
      this.allTagNameList = []
      for (const sitemap of targetSitemapList) {
        for (const tag of sitemap.tag_list) {
          this.allTagNameList.push(tag.name)
        }
      }
      this.allTagNameList = this.$_.union(this.allTagNameList)
    },
    /** 一括タグ編集モーダルクローズ */
    closeTagCollectEditModal () {
      this.isTagCollectEditModalOpen = false
    },
    /** 全コンテンツまたはURLに同じタグを追加する */
    collectAddTag (isAllSelected, selectSitemapList, addTagName) {
      this.collectTagEdit(SITEMAP_ACTION_TYPE.TAG_ALL_ADD, isAllSelected, selectSitemapList, addTagName)
    },
    /** 全コンテンツまたはURLから同じタグを削除する */
    collectDeleteTag (isAllSelected, selectSitemapList, dellTagName) {
      this.collectTagEdit(SITEMAP_ACTION_TYPE.TAG_ALL_DEL, isAllSelected, selectSitemapList, dellTagName)
    },
    /** 一括タグ編集 */
    collectTagEdit (action, isAllSelected, selectSitemapList, editTagName) {
      let editSitemap = []
      if(isAllSelected) {
        if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
          editSitemap = this.sitemapRecruitListAll
        } else if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
          editSitemap = this.sitemapCustomListAll
        } else {
          editSitemap = this.selectedSitemapRoot.node_list
        }
      } else {
        editSitemap = selectSitemapList
      }
      const sendData = {
        action       : action,
        edit_sitemap : editSitemap,
        edit_tag_name: editTagName,
        is_recruit   : this.isRecruit,
        pages        : this.pages,
        per_page     : this.perPage,
        page_type    : this.pageType,
        content_type : this.contentType
      }
      this.$store.dispatch(SITEMAP_DISPATCH.EDIT_ALL_SITEMAP_TAG, sendData)
      this.isTagProgress = true
    },
    /** タグ設定モーダルオープン */
    openTagEditModal (target) {
      this.targetSitemap = target
      this.collectionTag()
      this.isTagEditModalOpen = true
    },
    /** タグ収集 */
    collectionTag () {
      let targetSitemapList = []
      if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
        // 求人ページ
        targetSitemapList = this.sitemapRecruitList
      } else if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
        // カスタムページ
        targetSitemapList = this.sitemapCustomList
      } else {
        // ホームページ
        targetSitemapList = this.selectedSitemapRoot.node_list
      }
      let targetTagList = []
      for (const sitemap of targetSitemapList) {
        if (Number(sitemap.pk) === Number(this.targetSitemap.pk)) {
          targetTagList = sitemap.tag_list
          break
        }
      }
      if (targetTagList) {
        this.targetTagNameList = []
        for (const tag of targetTagList) {
          this.targetTagNameList.push(tag.name)
        }
      }
    },
    /** タグ設定モーダルクローズ */
    closeTagEditModal () {
      this.isTagEditModalOpen = false
    },
    /** タグの更新 */
    addSitemapTag (target, addTagName) {
      this.isTagProgress = true
      const addTagData = {
        sitemap_pk  : target.pk,
        add_tag_name: addTagName,
        is_recruit  : this.isRecruit,
        pages       : this.pages,
        per_page    : this.perPage,
        content_type: this.contentType
      }
      this.$store.dispatch(SITEMAP_DISPATCH.ADD_SITEMAP_TAG, addTagData)
    },
    /** タグの削除 */
    deleteSitemapTag (deleteTagName) {
      this.isTagProgress = true
      let deleteTagPk = 0
      for (const tag of this.targetSitemap.tag_list) {
        if (tag.name === deleteTagName) {
          deleteTagPk = tag.pk
        }
      }
      const sendData = {
        sitemap_pk    : this.targetSitemap,
        tag_pk        : deleteTagPk,
        is_str_recruit: this.isRecruit === true ? 'true' : 'false',
        pages         : this.pages,
        per_page      : this.perPage,
        content_type  : this.contentType
      }
      this.$store.dispatch(SITEMAP_DISPATCH.DEL_SITEMAP_TAG, sendData)
    },
    //////////////////////////////////////////
    // タグ検索関連
    /** 検索用タグリスト作成 */
    createTagList (targetList) {
      let allTags = []
      allTags = targetList
      if (this.isRecruit) {
        // ToDo
        // 求人ページとカスタムページで分ける
      }
      // タグ名だけを重複なしでリスト化
      let return_tag = this.$_.uniqBy(allTags, 'name')
      return return_tag
    },
    //////////////////////////////////////////
    // 制御関連
    /** 求人ページおよびカスタムページデータ取得 */
    getEploymentData () {
      this.$store.dispatch(SITEMAP_DISPATCH.SET_PAGE_NUMBER, this.pages)
      if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
        // 求人ページデータ取得
        const recruitPageData = {
          pages       : this.pages,
          per_page    : SITEMAP_OVERALL.PER_PAGE,
          content_type: SITEMAP_CONTENT_TYPE.RECRUIT_PAGE
        }
        this.$store.dispatch(SITEMAP_DISPATCH.GET_SITEMAP_RECRUIT_LIST, recruitPageData)
      }
      if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE) {
        // カスタムページデータ取得
        const customPageData = {
          pages       : this.pages,
          per_page    : SITEMAP_OVERALL.PER_PAGE,
          content_type: SITEMAP_CONTENT_TYPE.CUSTOM_PAGE
        }
        this.$store.dispatch(SITEMAP_DISPATCH.GET_SITEMAP_CUSTOM_LIST, customPageData)
      }
      this.isPageLoading = false
    },
    /** タブページ設定 */
    tabPageSet () {
      if (this.pageType === SITEMAP_PAGE_TYPE.RECRUIT_PAGE) {
        if (this.sitemapRecruitList.length > 0) {
          // 求人ページ(取得時にPV数でソート済み)
          this.isRecruit     = true
          this.contentType   = SITEMAP_CONTENT_TYPE.RECRUIT_PAGE
          this.countContents = this.countRecruitPage
          this.selectedList  = this.sitemapRecruitList
          // 初回起動ロボの初期設定
          this.initStartRobo()
          this.isPageLoading = false
        }
      } else if (this.pageType === SITEMAP_PAGE_TYPE.CUSTOM_PAGE){
        if (this.sitemapCustomList.length > 0) {
          // カスタムページ(取得時にPV数でソート済み)
          this.isRecruit     = true
          this.contentType   = SITEMAP_CONTENT_TYPE.CUSTOM_PAGE
          this.countContents = this.countCustomPage
          this.selectedList  = this.sitemapCustomList
          // 初回起動ロボの初期設定
          this.initStartRobo()
          this.isPageLoading = false
        }
      } else {
        if (this.selectedSitemapRoot) {
          // ホームページ
          this.isRecruit     = false
          this.contentType   = SITEMAP_CONTENT_TYPE.HOME_PAGE
          this.countContents = 0
          // 選択中のサイトマップを新しいデータで上書きする
          if (this.sitemapRootList) {
            for (const root of this.sitemapRootList) {
              if (root.pk === this.selectedSitemapRoot.pk) {
                this.$store.dispatch(SITEMAP_DISPATCH.SET_SELECT_SITEMAP, root)
                break
              }
            }
          }
          // クエリ付きURLを除外(/#除外対応は一旦非対応)
          //let anchorDelList = this.selectedSitemapRoot.node_list.filter(node => node.node_url.indexOf('/#') < 0)
          let queryDelList = null
          if (this.selectedSitemapRoot.node_list) {
            queryDelList = this.selectedSitemapRoot.node_list.filter(node => node.node_url.indexOf('?') < 0)
          } else {
            queryDelList = this.selectedSitemapRoot.node_list
          }
          // URL順にソート
          this.selectedList  = this.$_.orderBy(queryDelList, ['node_url'], ['asc'])
          // 初回起動ロボの初期設定
          this.initStartRobo()
          this.isPageLoading = false
        }
      }
    },
    /** リンクURL取得 */
    getLink (target) {
      let link = ''
      if (this.isRecruit) {
        // 求人ページ表示中
        link = target.contents_url
      } else {
        // ホームページ表示中
        if (target.node_url[0] != '/') {
          target.node_url = '/' + target.node_url
        }
        link = this.selectedSitemapRoot.root_url + target.node_url
      }
      return link
    },
    /** リンクタイトル取得 */
    getLinkTitle (target) {
      let title = ''
      if (this.pageType === SITEMAP_PAGE_TYPE.HOME_PAGE) {
        // ホームページ表示中
        if (target.node_url.indexOf('/recruit/main/') >= 0) {
          title = '会社概要ページ'
        } else {
          title = target.node_url ? target.node_url : 'No Title'
        }
      } else {
        // 求人ページ表示中
        if (target.contents) {
          title = target.contents.content.title ? target.contents.content.title : target.contents.title
        }
      }
      return decodeURI(title)
    },
    /** ロボ名取得 */
    getRoboName (target, robo) {
      let roboName = ''
      if (this.isStartRobo(target, robo)) {
        // 初回起動ロボ設定済み
        roboName = robo.data.name + '\n' + '[初回起動]'
      } else {
        roboName = robo.data.name
      }
      return roboName
    },
    /** ロボアイコン取得 */
    getRoboIcon (robo) {
      let icon = null
      if (!robo) {
        icon = require('@/assets/template/robot.png')
      } else if (robo.data.icon) {
        icon = robo.data.icon
      } else if (robo.data.icon_ref) {
        icon = robo.data.icon_ref
      } else if (robo.data.default_icon_ref) {
        icon = robo.data.default_icon_ref
      } else {
        icon = require('@/assets/template/robot.png')
      }
      return icon
    },
    /** 初回起動ロボ初期表示設定 */
    initStartRobo () {
      if (this.selectedList) {
        this.selectStartRobo = {}
        for (const node of this.selectedList) {
          if (node.start_robo) {
            this.selectStartRobo[node.sitemap_id] = node.start_robo
          } else if (node.start_minirobo) {
            this.selectStartRobo[node.sitemap_id] = node.start_minirobo
          }
        }
      }
    },
    /** 初回起動ロボ判定 */
    isStartRobo (target, robo) {
      let isStart = false
      if (target.start_robo) {
        // ロボの初回起動判定
        if (target.start_robo.data.pk === robo.data.pk) {
          isStart = true
        }
      } else if (target.start_minirobo) {
        // ミニロボの初回起動判定
        if (target.start_minirobo.data.pk === robo.data.pk) {
          isStart = true
        }
      }
      return isStart
    },
    /** ロボ適用対象ページまたはURL取得 */
    getApplyTargetName (target) {
      let targetName = ''
      if (this.isRecruit) {
        // 求人ページ表示中
        targetName = target.contents.content.title ? target.contents.content.title : target.contents.title
      } else {
        // ホームページ表示中
        targetName = this.selectedSitemapRoot.root_url + target.node_url
      }
      return targetName
    },
    /** シナリオ編集画面表示 */
    changeScnList (robo) {
      let isMatch = false
      for (const org_robo of this.chatbots) {
        for (const minirobo of org_robo.chatbot_mini) {
          if (minirobo.bot_id === robo.data.bot_id) {
            this.$emit('changeScnList', org_robo.scenario_name, org_robo)
            isMatch = true
            break
          }
        }
        if (!isMatch && (org_robo.bot_id === robo.data.bot_id)) {
          this.$emit('changeScnList', org_robo.scenario_name, org_robo)
          isMatch = true
          break
        }
        if (isMatch) {
          break
        }
      }
    },
    /** ロボアイコンにマウスオーバーで「x」ボタン表示 */
    roboOver (robo) {
      this.roboIconHover = robo
    },
    /** ロボアイコンにマウスリーブで「x」ボタン非表示 */
    roboLeave (robo) {
      this.roboIconHover = ''
    },
    /** ロボアイコンにマウスオーバーで「x」ボタン表示 / マウスリーブで「x」ボタン非表示 */
    isIconHover (robo) {
      if (this.roboIconHover === robo) {
        return true
      } else {
        return false
      }
    },
     /** 新規サイトマップルート登録 */
    registSitemapWait (createSitemapUrl) {
      this.$emit('registSitemapWait', createSitemapUrl)
      this.createSitemapUrl = ''
    },
    isRoboEditPermission (robo) {
      const targetRobo = this.chatbots.find((target) => target.bot_id === robo.data.bot_id)
      return isRoboEditPermission(targetRobo, this.user)
    }
  }
}
</script>

<style scoped>
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.tab-form {
  width:100%;
  height: 400px;
  padding: 8px;
}
.tab-header {
  margin-top: 16px;
  margin-left: 8px;
  margin-bottom: 16px;
}
.tab-item {
  width: 100%;
  height: calc(100% - 50px);
  padding:12px;
}
.cell-class {
  padding: 0.5em !important;
}
.th-class {
  text-align: center;
  vertical-align: middle;
}
.split-box-form {
  width: 60%;
  display: flex;
  align-items: right;
}
.split-box-left {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.split-box-right {
  width: 80%;
  font-size: 13px;
  padding-right: 48px;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}
.robo-split-box-form {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.robo-split-box-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.robo-split-box-right {
  width: 56px;
  font-size: 13px;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}
.bot-enable-list {
  position: relative;
  margin: 4px;
}
.bot-icon {
  height: 36px;
  width:  36px;
  border-radius: 50%;
  border: solid thin #ccc;
  object-fit: cover;
  background: white;
}
.delete-button {
  position: absolute;
  top:   -5px;
  right: -5px;
  height: 16px;
  width:  16px;
  border-radius: 50%;
  line-height: 0.95;
  border: solid thin #ccc;
  background: rgb(255, 255, 255);
  cursor: pointer; 
}
.edit-button {
  position: absolute;
  top:   -5px;
  left:  -5px;
  height: 16px;
  width:  16px;
  border-radius: 50%;
  line-height: 0.95;
  border: solid thin #ccc;
  background: rgb(248, 147, 172);
  z-index: 100;
}
.start-tag {
  position: absolute;
  top: 0;
  height: 9px;
  width:  9px;
  border-radius: 50%;
  background: rgb(250, 70, 30);
}
.notfound-sitemap {
  width: 100%;
  height: 100%;
  background: white;
  margin-top: 40px;
}
.create-box-form {
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
}
.create-box-right {
  width: 80%;
  font-size: 13px;
  padding-right: 48px;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}
.create-box-left {
  width: 20%;
  justify-content: center;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components2/Robo/screen/organisms/SitemapTable.vue